/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import BaseExhibitorsTemplate from '@bottlebooks/gatsby-theme-event-pages/src/templates/ExhibitorsTemplate';
import { graphql as gatsbyGraphQL } from 'gatsby';

export * from '@bottlebooks/gatsby-theme-event-pages/src/templates/ExhibitorsTemplate';

export default function ExhibitorsTemplate({
  data,
  pageContext,
  location,
  navigate,
}) {
  return (
    <BaseExhibitorsTemplate
      data={afterQuery(data)}
      pageContext={pageContext}
      location={location}
      navigate={navigate}
    />
  );
}

export const fragment = gatsbyGraphQL/* GraphQL */ `
  fragment vv_Registration_exhibitorPackage on Bottlebooks_SingleRegistration {
    exhibitorPackage: customFieldValue(key: "exhibitorPackage") {
      ... on Bottlebooks_SelectFieldValue {
        key
      }
    }
  }

  query vv_ExhibitorsTemplate(
    $eventId: ID!
    $locale: Bottlebooks_ContentLocale
    $filter: ExhibitorFilterInput
    $sort: ExhibitorSortInput
    $localeString: String
  ) {
    bottlebooks {
      event(eventId: $eventId, locale: $locale) {
        ...ExhibitorsTemplate_Bottlebooks_Event
        exhibitors {
          nodes {
            ...vv_exhibitorFilters_Exhibitor
          }
        }
        registrations {
          nodes {
            companyId
            ...vv_exhibitorFilters
            ...vv_exhibitorPackage
            ...vv_ExhibitorCard_Registration
          }
        }
      }
    }
    event(locale: { eq: $localeString }) {
      ...ExhibitorsTemplate_Event
    }
    firstExhibitors: allExhibitor(filter: $filter, sort: $sort, limit: 10) {
      nodes {
        ...ExhibitorsPage_first
      }
    }
    exhibitors: allExhibitor(filter: $filter, sort: $sort) {
      nodes {
        exhibitorId
        ...ExhibitorsPage
      }
    }
    ...ExhibitorsTemplate_Query
  }

  fragment ExhibitorsTemplate_Event on Event {
    # This is how we should do this in the future - take the settings from event
    # But for the moment, we are loading them from environment variables using useSiteConfig
    # filterSeekingDistribution
    # filterHasDistribution
    ...ExhibitorsPage_Event
  }

  fragment ExhibitorsTemplate_Query on Query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;

function afterQuery({ bottlebooks, ...rest }) {
  const event = bottlebooks.event;
  const data = {
    bottlebooks: {
      ...bottlebooks,
      event: {
        exhibitors: {
          ...event?.exhibitors,
          nodes: event?.exhibitors?.nodes?.map((exhibitor) => {
            const registration = event?.registrations.nodes.find(
              (registration) => registration.companyId === exhibitor.exhibitorId
            );
            return wipePremiumData({
              ...exhibitor,
              ...registration,
              ...registration?.profile,
            });
          }),
        },
      },
    },
    ...rest,
  };
  return data;
}

function wipePremiumData(exhibitor) {
  const exhibitorPackage = exhibitor.exhibitorPackage?.key;
  if (exhibitorPackage === 'premium' || exhibitorPackage === 'pavilion') {
    return exhibitor;
  }
  const { offeringTypes: _1, ...rest } = exhibitor;
  return rest;
}
